import React, { useState, useEffect, useMemo } from 'react';
import { Col, Nav, Offcanvas, Row } from 'react-bootstrap';
import notify from '../../assets/images/Notification.png';
import earthquake from '../../assets/images/earthquake.svg';
import unknown from '../../assets/images/unknown.svg';
import { useNavigate, Link, useLocation } from "react-router-dom";

import RangeSlider from './RangeSlider';
import GoogleMap from 'components/GoogleMap';
import { userService } from 'services';
import AvailableJobsPreview from './AvailableJobsPreview';
import RequestedJobsPreview from './RequestedJobsPreview';
import addimg from '../../assets/images/add.svg';

import CreateJob from './CreateJob';
import MissingForm from 'components/Modals/FormPopup/MissingForm';

import NaturalDisaster from 'components/Modals/FormPopup/NaturalDisaster';
import useCurrentUser from 'hooks/useCurrentUser';
import Loader from 'components/Loader';
import useNotificationList from 'hooks/useNotificationList';

const HomeContent = () => {
    const { user: currentUser, loading: isLoading, setUser } = useCurrentUser();
    const { roleType, coordinates, address, pilotJobLocationRadius } = currentUser || {};

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pilotRadius, setPilotRadius] = useState(null);
    const [location, setLocation] = useState({
        lat: coordinates?.length > 0 ? coordinates[1] : 0,
        lng: coordinates?.length > 0 ? coordinates[0] : 0
    });
    const [data, setData] = useState(
        {
            label: address,
            value: { place_id: '' }
        }
    );
    const [userAddress, setUserAddress] = useState(address);
    const [nearbyPilots, setNearbyPilots] = useState([]);


    const fetchNearbyPilots = async () => {
        try {
            const response = await userService.fetchPilotsWithCords();
            setNearbyPilots(response.data.data.pilots || response.data.data || []);
        } catch (err) {
            console.error("Error fetching nearby pilots:", err);
        }
    }

    useEffect(() => {
        if (roleType === 'CLIENT' && location.lat && location.lng) {
            fetchNearbyPilots();
        }
    }, [roleType, location])


    const handleUpdateLocation = async () => {
        const payload = {
            latitude: location?.lat,
            longitude: location?.lng,
            address: userAddress
        }
        try {
            setLoading(true);
            const response = await userService.updateUserLocation(payload);
            localStorage.setItem('userData', JSON.stringify(response?.data?.data));

        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false);
        }
    }

    const updateRadius = async (radius) => {
        const response = await userService.updateRadius({ pilotJobLocationRadius: radius });
        response.data.success && setPilotRadius(radius);
        setUser({
            ...currentUser,
            ...response?.data?.data
        });
    }

    useEffect(() => {
        if (address !== userAddress) {
            handleUpdateLocation();
        }
    }, [location, userAddress])

    if (isLoading) {
        return <Loader loading={isLoading} />
    }

    return (
        <div className="dashboard">
            <TopHeader />
            <div className="container-box">
                <Row>
                    <Col xl={roleType === 'PILOT' ? 7 : 12}>
                        <div className='map-image' >
                            <GoogleMap
                                location={location}
                                setLocation={setLocation}
                                setUserAddress={setUserAddress}
                                data={data}
                                setData={setData}
                                loading={loading}
                                mapTypeControl={false}
                                streetViewControl={false}
                                fullscreenControl={false}
                                radius={roleType === 'PILOT' ? (pilotRadius || pilotJobLocationRadius) : null}
                                pilots={nearbyPilots}
                            />
                        </div>
                    </Col>
                    {roleType === "PILOT" && (
                        <Col xl={5} className='z-50'>
                            <div className='right-bar-d pt-3 pb-2 px-3'>
                                <RangeSlider radius={pilotJobLocationRadius} handleComplete={updateRadius} />
                                <AvailableJobsPreview pilotRadius={pilotRadius} />
                            </div>
                        </Col>)}
                </Row>
            </div>
        </div>
    )
}

export default HomeContent;


export const TopHeader = () => {
    const [show, setShow] = useState(false);
    const [notificationshow, setNotificationShow] = useState(false);
    const [missingShow, setMissingShow] = useState(false)
    const [disasterShow, setDisasterShow] = useState(false)
    const [dataLength, setDataLength] = useState({
        skip: 0,
        limit: 500
    })

    const { user: currentUser } = useCurrentUser();
    const { roleType } = currentUser || {};

    const { notificationsData } = useNotificationList(dataLength);
    const { totalNotifications, notifications } = notificationsData || {};

    const isAllNotificationRead = useMemo(() => {
        if (notifications?.length) {
            return notifications.every(item => item?.isRead)
        }
    }, [notifications])

    const handleClose = () => {
        setShow(false);
        setMissingShow(false);
        setDisasterShow(false)
        setNotificationShow(false)
    };
    const handleShow = () => {
        setShow(true);
    };

    return <>
        <div className="container-box" style={{ minHeight: 'unset' }}>
            <div className='top-head d-flex flex-wrap justify-content-between align-items-center gap-2'>
                <div>
                    <h2>Dashboard</h2>
                </div>
                <div className='d-flex gap-2'>
                    <div className='d-flex gap-2 flex-md-nowrap flex-wrap'>
                        <button onClick={() => setMissingShow(true)} className='btn  d-flex gap-2 align-tems-center  gray-btn' href="/" >
                            <img alt='' src={unknown}></img>
                            Missing Person
                        </button>
                        <MissingForm show={missingShow} handleClose={handleClose} />
                        <button onClick={() => { setDisasterShow(true) }} className='btn  d-flex gap-2 align-items-center gray-btn' >
                            <img alt='' src={earthquake}></img>
                            Natural Disaster
                        </button>
                        <NaturalDisaster show={disasterShow} handleClose={handleClose} />
                        {roleType === "CLIENT" && (
                            <div onClick={handleShow} className='btn  d-flex gap-2 align-items-center gray-btn' >
                                <img alt='' src={addimg} />
                                Create Job
                            </div>
                        )}
                    </div>
                    <Nav.Link as={Link} to="/notification" href="/notification">
                        <div className="position-relative">
                            <img alt='' src={notify} onClick={() => setNotificationShow(true)} />
                            {totalNotifications > 0 ? (<>
                                {isAllNotificationRead ? <></> : (
                                    <span className="position-absolute badge-custom rounded-circle">
                                        <span className="visually-hidden">New alerts</span>
                                    </span>
                                )}
                            </>) : null}

                        </div>
                    </Nav.Link>
                </div>
            </div>
        </div>


        <CreateJob show={show} setShow={setShow} onHide={handleClose} />

    </>
}